import React, {useEffect} from 'react';
import {Controller} from "react-hook-form";
import {
		Box,
		Button,
		Card,
		CardContent,
		CardHeader,
		Divider,
		Grid,
		TextField,
} from '@material-ui/core';
import {useNavigate, useParams} from "react-router";
import FormLoading from "../../../components/FormLoading";
import {useCrudForm} from "../../../hooks/crud/Form";
import {useTranslation} from "react-i18next";
import SettingRepository from "../../../repositories/SettingRepository";

const Form = () => {
	const navigate = useNavigate();
	const {t} = useTranslation();

	const {id} = useParams();

	const repository = new SettingRepository();

	const { form, onSubmit, isSubmitting, hasError, errorMessage } =
        useCrudForm(repository, { id: id, onSuccess: () =>  navigate("/app/settings") });
    const { control, register, unregister, setValue } = form;

	 return (
			<form onSubmit={onSubmit}
			>
                 <Grid item xs={12} lg={8}>
                     {isSubmitting && <FormLoading />}
                        <Grid container>
                            <Grid item lg={6} xs={12}>
                                <Box p={0.5}>
                                    <Card>
                                        <CardHeader title={t('Information')} />
                                        <Divider />
                                        <CardContent>
                                             <Box mt={3}>
                                                <Controller
                                                     as={TextField} control={control}
                                                     error={hasError('Value')}
                                                     fullWidth
                                                     helperText={errorMessage('Value')}
                                                     label={t('Value')}
                                                     type={"text"}
                                                     name="Value"
                                                     defaultValue={""}
                                                     variant="outlined"
                                                     rules={{ required: false }}
                                                />
                                             </Box>
                                        </CardContent>
                                     </Card>
                                </Box>
                            </Grid>
                        </Grid>
                     </Grid>
                     <Box mt={2}>
                         <Button
                            color="secondary"
                            variant="contained"
                            type="submit"
                            name="submit"
                            disabled={isSubmitting}
                        >
                            {t('Save')}
                        </Button>
                     </Box>
                </form>
	);
};

export default Form;